import { useNavigate } from 'react-router-dom';
import { Box, Typography } from "@mui/material"
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DownloadPDFButton from '../DownloadPDFButton/index.js';

const AppContentHeader = ({ backLabel, hasBackLink = false, onBack, pdfDownloadUrl, pdfName }) => {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        position: 'relative',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer'
        }}
        onClick={() => hasBackLink ? onBack() : navigate(-1)}
      >
        <ArrowBackIcon
          sx={{
            color: 'white'
          }}
        />
        <Typography variant="body" color="white" ml="8px">
          Back {backLabel && `to ${backLabel}`}
        </Typography>
      </Box>
      {pdfDownloadUrl && <DownloadPDFButton pdfDownloadUrl={pdfDownloadUrl} pdfName={pdfName}/>}
    </Box>
  )
}

export default AppContentHeader